import { errorAlert } from '../alertsActions';
import alertMessages from '../../intl/common/alertMessages';
import {domains} from '../../constants/Utils';
import {
    validateAnsweringSchemaCreateEvent,
    validateAnsweringSchemaUpdateEvent
} from '../../api/validation/answeringSchema';
import {aseWebsocketCommands} from '../../constants/aseWebsocketCommands';


export const updateAnsweringSchema = (domain, data) => dispatch => {
    const { error } = validateAnsweringSchemaUpdateEvent(data);
    if (error) {
        switch (domain) {
            case domains.ASE: {
                dispatch(errorAlert(alertMessages.ANSWERING_SCHEMA_UPDATE_SEND_ERROR, [error.toString()]));
                dispatch({type: aseWebsocketCommands.ASE_ANSWERING_SCHEMA_SAVE_UPDATE_ERROR});
                break;
            }
        }
    } else {
        switch (domain) {
            case domains.ASE: {
                return dispatch({
                    type: aseWebsocketCommands.ASE_ANSWERING_SCHEMA_UPDATE_PENDING,
                    aseWebsocket: true,
                    command: aseWebsocketCommands.ASE_ANSWERING_SCHEMA_UPDATE,
                    payload: {
                        payload: {
                            ...data
                        }
                    }
                });
            }
        }
    }
};

export const saveAnsweringSchema = (domain, data) => dispatch => {
    let shouldContinue = true;
    data.forEach(item => {
        const {error} = validateAnsweringSchemaCreateEvent(item);
        if (error && domains.ASE) {
            dispatch(errorAlert(alertMessages.ANSWERING_SCHEMA_NEW_SEND_ERROR, [error.toString()]));
            dispatch({type: aseWebsocketCommands.ASE_ANSWERING_SCHEMA_SAVE_NEW_ERROR});
            shouldContinue = false;
        }
    });
    if (shouldContinue && domain === domains.ASE) {
        data.forEach(item => {
            dispatch({
                type: aseWebsocketCommands.ASE_ANSWERING_SCHEMA_CREATE_PENDING,
                aseWebsocket: true,
                command: aseWebsocketCommands.ASE_ANSWERING_SCHEMA_CREATE,
                payload: {
                    payload: {
                        ...item,
                    }
                }
            })
        });
    }

};

export const fetchAnsweringSchema = (domain, id, ipn) => dispatch => {
    switch (domain) {
        case domains.ASE: {
            return dispatch({
                type: aseWebsocketCommands.ASE_ANSWERING_SCHEMA_DETAIL_FETCH_PENDING,
                aseWebsocket: true,
                command: aseWebsocketCommands.ASE_ANSWERING_SCHEMA_DETAIL,
                payload: {
                    answeringSchema: {
                        id
                    },
                }
            });
        }
    }
};

export const resetAnsweringSchema = (domain) => dispatch => {
    switch (domain) {
        case domains.ASE: {
            return dispatch({
                type: aseWebsocketCommands.ASE_ANSWERING_SCHEMA_RESET,
            });
        }
    }
};


export const redirectReset = (domain) => dispatch => {
    switch (domain) {
        case domains.ASE: {
            return dispatch({
                type: aseWebsocketCommands.ASE_ANSWERING_SCHEMA_REDIRECT_RESET,
            });
        }
    }
};
